import { ReactNode } from 'react';
import styled from '@emotion/styled';

import { RecommendOptionValueModel } from '../utils/types';

export interface SimilarSizeOptionProps {
  items: Array<RecommendOptionValueModel>;
  renderItem: (item: RecommendOptionValueModel) => ReactNode;
}

export function SimilarSizeOptionList({ items, renderItem }: SimilarSizeOptionProps) {
  return <Wrapper>{items.map(renderItem)}</Wrapper>;
}

const Wrapper = styled.ul`
  padding: 0 24px 12px;
`;
